export const updateAuditControlMutation = () => {
    return `
    mutation UpdateAuditControl(
        $auditControlId: Int!,
        $objectiveId: Int,
        $mainSystemId: Int,
        $hrSystemId: Int,
        $ticketSystemId: Int,
        $systemConsolidations: JSONString,
        $auditId: Int,
        $controlOwnerId: NonEmptyString,
        $controlItId: NonEmptyString,
        $isHidden: Boolean,
        $isAutomated: Boolean,
        $isCreationEqualsOnboardingApproval: Boolean
    ) {
        updateAuditControl(
            auditControlId: $auditControlId,
            objectiveId: $objectiveId,
            mainSystemId: $mainSystemId,
            hrSystemId: $hrSystemId,
            ticketSystemId: $ticketSystemId,
            systemConsolidations: $systemConsolidations,
            auditId: $auditId,
            controlOwnerId: $controlOwnerId,
            controlItId: $controlItId,
            isHidden: $isHidden,
            isAutomated: $isAutomated,
            isCreationEqualsOnboardingApproval: $isCreationEqualsOnboardingApproval
        ) {
            auditControl {
                id
                isHidden
                isAutomated
            }
        }
    }
    `
}
